<template>
  <div class="my-header">
    <www-picture v-if="width" :img="bg" :w="`${width}`" :h="`${height}`" class="bg" objectFit="cover" />
    <div class="header-pg-cover" :class="{ 'header-pg-cover-en': !$isCN(), 'about-us': useAboutUsStyle }" v-if="name || $slots.name">
      <div class="header-pg-cover-name">
        <slot name="name">
          {{ name }}
        </slot>
      </div>
      <div class="header-pg-cover-name-second">
        <slot name="nameSecond">
          {{ nameSecond }}
        </slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["name", "nameSecond", "bg", "useAboutUsStyle"],
  data() {
    return {
      width: 0,
      height: 0,
    };
  },
  mounted() {
    if (this.$isMob()) {
      this.width = 750;
      this.height = 400;
      return;
    }
    const ratio = 1320 / 400;
    this.width = parseInt(window.innerWidth * (1320 / 1440));
    this.height = parseInt(this.width / ratio);
  },
};
</script>

<style lang="less" scoped>
.my-header {
  height: 460px;
  position: relative;
}

.bg {
  position: absolute;
  top: 60px;
  bottom: 0;
  right: 0;
  width: 92%;
}

.header-pg-cover {
  width: 667px;
  height: 334px;
  background: rgba(255, 87, 26, 0.9);
  display: flex;
  flex-direction: column;
  padding-left: 246px;
  justify-content: center;
  box-sizing: border-box;
  position: relative;

  &-name {
    font-style: normal;
    font-weight: 600;
    font-size: 44px;
    line-height: 54px;
    color: #ffffff;
    text-transform: capitalize;
  }

  &-name-second {
    font-style: normal;
    font-weight: 400;
    font-size: 20px;
    line-height: 28px;
    color: #ffffff;
    margin-top: 16px;
  }
}

.header-pg-cover-en {
  padding-left: 150px;
}

.about-us {
  .header-pg-cover {
    &-name-second {
      font-size: 16px;
      line-height: 22px;
    }
  }
}

@media screen and (max-width: 540px) {
  .my-header {
    height: 200px;
    display: flex;
    align-items: center;
  }
  .bg {
    position: absolute;
    top: 0;
    bottom: 0;
    right: 0;
    width: 100%;
  }
  .header-pg-cover {
    width: 250px;
    height: 127px;
    padding-left: 20px;

    &-name {
      font-size: 20px;
      line-height: 24px;
    }

    &-name-second {
      font-size: 11px;
      line-height: 18px;
      margin-top: 11px;
    }
  }

  .about-us {
    .header-pg-cover {
      &-name {
        font-size: 16px;
        line-height: 20px;
      }

      &-name-second {
        font-size: 11px;
        line-height: 14px;
        margin-top: 4px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/MyHeader.vue